import { Link } from "react-router-dom";
import Button from "../Button";

const CompanyCard = ({ logo, name, questions, difficulty }) => {
  return (
    <div className="col-md-4 col-12 mb-4">
      <div className="rounded-lg border bg-dark border-primary hover-card h-100">
        <div className="p-4 text-center">
          <img
            src={logo}
            alt={name}
            className="rounded-circle mb-3"
            style={{ width: "60px", height: "60px", objectFit: "cover" }}
          />
          <h5 className="fw-bold text-light mb-2">{name}</h5>
          <p className="text-muted mb-3">
            {questions} Interview Questions
          </p>
          <div className="d-flex justify-content-center mb-3">
            <span
              className={`badge ${
                difficulty === "Hard"
                  ? "bg-danger"
                  : difficulty === "Medium"
                  ? "bg-warning text-dark"
                  : "bg-success"
              }`}
            >
              {difficulty}
            </span>
          </div>
          <Link to={`/placement/${name}`}>
          <Button variant="gradient" fullWidth>Practice Now</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CompanyCard;
